import React from 'react';
import ProductSearchItem from '../ProductSearchItem';

// Memoized wrapper untuk mencegah re-render
const ProductOptionLabel = React.memo(({ product }) => {
    return <ProductSearchItem product={product} />;
});

ProductOptionLabel.displayName = 'ProductOptionLabel';

export default ProductOptionLabel;
